import { Language } from '../types/lang'

export const getCurrentTextLanguage = (obj: Language) => {
  const language = localStorage.getItem('language') || 'esp'
  if (language === 'eng') {
    return obj.eng
  }

  if (language === 'esp') {
    return obj.esp
  }

  return 'unknown'
}

export const getAuthorName = (obj: Language) => {
  const language = localStorage.getItem('language') || 'esp'

  if (language === 'eng') {
    return obj.eng
  }

  if (language === 'esp') {
    return obj.eng
  }

  return 'unknown'
}

export const getLanguageText = (l: string) => {
  const language = localStorage.getItem('language') || 'esp'
  if (language === 'arm') {
    if (l === 'arm') {
      return 'հայերեն'
    }

    if (l === 'cat') {
      return 'կատալերեն'
    }

    if (l === 'eng') {
      return 'անգլերեն'
    }

    if (l === 'esp') {
      return 'իսպաներեն'
    }

    return 'լեզու'
  }

  if (language === 'cat') {
    if (l === 'arm') {
      return 'armeni'
    }

    if (l === 'cat') {
      return 'català'
    }

    if (l === 'eng') {
      return 'anglès'
    }

    if (l === 'esp') {
      return 'espanyol'
    }

    return 'català'
  }

  if (language === 'eng') {
    if (l === 'arm') {
      return 'armenian'
    }

    if (l === 'cat') {
      return 'catalan:'
    }

    if (l === 'eng') {
      return 'english'
    }

    if (l === 'esp') {
      return 'spanish'
    }

    return 'english'
  }

  if (language === 'esp') {
    if (l === 'arm') {
      return 'armenio'
    }

    if (l === 'cat') {
      return 'catalán'
    }

    if (l === 'eng') {
      return 'inglés'
    }

    if (l === 'esp') {
      return 'español'
    }

    return 'հայերեն'
  }
  return 'def'
}

export const keyGenerator = (id: string) => {
  return Date.now() + Math.floor(Math.random() * 1000) + id
}

export const capitalize = (s: string) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
